import { environmentConfig } from "@src/appV2/environment";

export const GET_FACILITY_DAY_SHIFTS_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/calendar/facility`;
